<!-- eslint-disable no-unreachable -->
<template>
      <v-card :color="backgroundColor" style="border-radius: 5px;"
>
        <v-card flat tile :color="stateColor(order.state)" style="border-radius: 5px 5px 0 0 !important;" class="darken-4">
          <v-card-text class="py-3">
            <v-row>
              <v-col cols="4" class="pr-0">
                <div class="font-weight-strong" v-if="
                    order.sequence === null ||
                      order.sequence === '' ||
                      order.sequence === '0'
                  " style="font-weight: 700 !important; font-size: 18px; color: white;">
                  #{{order.orderId}}
                  </div>

                  <div v-else class="font-weight-strong" style="font-weight: 700 !important; font-size: 18px; color: white;">
                    #{{ order.sequence }} 
                  </div>

              </v-col>

              <v-col cols="8" class="text-right white--text pl-0 pr-0 " >
                <span class="white--text rounded-xl pa-1" v-if="fulfillment === 'takeAway'" style="font-weight: 700 !important; font-size: 0.5em !important; border-style: solid; border-width: 1px;"> Take-away</span>

                <span class="white--text rounded-xl pa-1" v-else-if="fulfillment === 'delivery'" style="font-weight: 700 !important; font-size: 0.5em !important; border-style: solid; border-width: 1px;"> Delivery</span>

                <span class="white--text rounded-xl pa-1" v-else-if="fulfillment === 'eatIn'" style="font-weight: 700 !important; font-size: 0.5em !important; border-style: solid; border-width: 1px;"> Eat-in</span>

                <span class="white--text rounded-xl pa-1" v-else style="font-weight: 700 !important; font-size: 0.5em !important; border-style: solid; border-width: 1px;"> Eat-in</span>

                <span class="white--text rounded-xl pa-1 ml-2" style="font-weight: 700 !important; font-size: 0.5em !important; border-style: solid; border-width: 1px;">{{orderOrigin}}</span>
                
              </v-col>
              
            </v-row>
          </v-card-text>
        </v-card>

        <v-card flat tile :color="stateColor(order.state)" class="darken-4 white--text mb-0 pb-0 pt-1">

          <v-card-text class="py-3">

            <v-row style="margin-top: -30px">

              <v-col cols="6"> 

                <div v-if="this.order !== null && this.order !== undefined && this.order.locationVariation !== null && this.order.locationVariation !== undefined" class="font-weight-strong" style="font-weight: 700 !important; font-size: 14px; color: white;" >
                  {{ locationVariationText }}
                </div>

              </v-col>

              <v-col cols="6" class="text-caption font-weight-strong text-right pr-0 pl-0" style="font-weight: 700 !important; color:white" v-if="order.deliveryTimeInMillis !== null && order.deliveryTimeInMillis !== undefined">
                {{ deliveryTimeFormatted }}
              </v-col>

              <v-col v-else cols="6" class="text-caption  text-right pr-0 pl-0" style="font-weight: 700 !important; color: white">
                {{ fromNow }}
              </v-col>

            </v-row>

          </v-card-text>

        </v-card>
        
        <v-card flat tile :color="stateColor(order.state)" class="darken-4 white--text" v-if="order.customer !== null && order.customer !== undefined" style="font-weight: 700 !important;">
          
          <v-divider class="mt-0 pt-0 mr-3 ml-3"></v-divider>

          <v-card-text class="mt-3 pt-3">

            <v-row dense style="margin-top: -20px">

              <v-col cols="6" v-once style="font-weight: 700 !important; color: white"> 

                <div style="font-size: 0.5em !important;">{{ order.customer.address.name_line }}</div>

              </v-col>

              <v-col v-once cols="6" class="text-right" style="font-weight: 700 !important; color: white">

                <div style="font-size: 0.5em !important;">{{ order.customer.phone }}</div>

              </v-col>

            </v-row>

          </v-card-text>

        </v-card>

        <LineItemList
          class="pt-0"
          :lineItems="lineItems"
          :order-state="order.state"
        />
        
        <v-card-text v-once class="pt-1 pb-1" v-if="orderComment!== null">
          <p class="mb-0 font-weight-bold">Comment: </p>
          <p style=" white-space: pre-line;" v-html="orderComment"></p>
        </v-card-text>
        <div v-if="showError">
          <v-alert
            type="error"
            :icon="false"
            dense
            tile
            class="mb-0"
            dismissible
            @click="showError = false"
          >
            <div style="font-size: 14px;">
              Could not update order state. Please try again.
            </div>
          </v-alert>
        </div>
        <v-card-text
          v-once
          class="pb-0"
          v-if="
            order.tags !== null &&
              order.tags !== undefined &&
              order.tags.length > 0
          "
        >
          <template v-for="(tag, index) in order.tags">
            <div v-if="tag !== null && tag !== undefined && tag.name !== null && tag.name !== undefined && !tagInlcudesTakeaway(tag)" :key="index">{{ tag.name }}</div>
          </template>
        </v-card-text>

        <v-card-actions class="pa-0">
          <v-card flat tile width="100%" :color="stateColor(order.state)" style="border-radius: 0 0 5px 5px !important;" class="darken-4">
            <v-card-text class="px-3 py-0 ma-0">

              <v-row >
                <v-col cols="3">
                  <v-btn
                    :loading="processingBackward"
                    :disabled="processingBackward"
                    depressed
                    @click.stop="processOrderStateBackward"
                    large
                    icon>
                      <v-icon
                        dark
                        left
                      >
                        mdi-skip-previous
                      </v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="6" class="text-center">
                  <div class="white--text pt-3 pb-3" style="font-size: 8px; font-weight: 700; height: 100%;">{{ order.state }}</div>
                </v-col>
              
                <v-col cols="3" class="text-center">
                  <v-btn
                    :loading="processingForward"
                    :disabled="processingForward"
                    depressed
                    @click.stop="proceedOrderStateForward"
                    icon
                    large
                  >
                    <v-icon
                      dark
                      left
                    >
                      mdi-skip-next
                    </v-icon>
                  </v-btn>
                </v-col>
            </v-row>
            </v-card-text>       
          </v-card>
        </v-card-actions>
    </v-card>
</template>

<script>
import moment from "moment-timezone"
import { StarPrinterConnect } from '@noona-hq/salescloud-star-printer-connect'

export default {
  name: "Order",
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      millisecondCount: 0,
      processingForward: false,
      processingBackward: false,
      interval: null,
      fromNow: null,
      showError: false,
      styleForPrinterTicket: " html, body {\n width: 100%;  font-size: 32px;\n   margin: 0;\n   padding: 0;\n   font-family: Sans-serif;\n}\n h1 {\n   margin-bottom: 10px;\n   margin-top: 0;\n}\n h2, h3, h4, h5, h6 {\n   margin-top: 0;\n   margin-bottom: 7px;\n}\n hr {\n   border-top: 0;\n}\n caption {\n   text-align: left;\n   font-size: 22px;\n}\n th {\n   font-size: 32px;\n}\n .text-small {\n   font-size: 24px;\n}\n .text-normal {\n   font-size: 32px;\n}\n .text-large {\n   font-size: 46px;\n}\n .text-center {\n   text-align: center;\n}\n .text-left {\n   text-align: left;\n}\n .text-right {\n   text-align: right;\n}\n .text-bold {\n   font-weight: bold;\n}\n .text-italic {\n   font-style: italic;\n}\n .text-no-wrap {\n   white-space: nowrap;\n}\n .strike-through {\n   text-decoration: line-through;\n}\n .table {\n   width: 100%;\n}\n .table td {\n   padding-left: 10px;\n   padding-right: 10px;\n}\n .table tr td:first-child {\n   padding-left: 0;\n}\n .table tr td:last-child {\n   padding-right: 0;\n}\n .table .line-item-row {\n   padding-top: 2px;\n   margin-bottom: 2px;\n   padding-bottom: 2px;\n}\n .receipt-border-bottom {\n   border-bottom: 0px solid #000;\n}\n .receipt-seperator {\n   border-top: 0;\n   height: 1px;\n   padding-bottom: 1px;\n   width: 100%;\n   display: block;\n   border-bottom: 2px solid #000;\n}\n .tags {\n   margin-top: 5px;\n   margin-bottom: 10px;\n   text-align: center;\n}\n .tag {\n   background: #000;\n   color: #fff;\n   padding: 5px 10px;\n   border-left: 5px solid transparent;\n   border-right: 5px solid transparent;\n}\n .receipt-header p {\n   margin-bottom: 5px;\n}\n .text-variation {\n   font-size: 22px !important;\n}\n .sales-kitchen-receipt-dynamic-description {\n   font-size: 18px;\n}\n"
    };
  },
  components: {
    'LineItemList': () => import('./LineItemList.vue')
  },
  computed: { 
    orderOrigin() {
      if (this.order !== null && this.order !== undefined && this.order.origin !== null && this.order.origin !== undefined && this.order.origin !== '') {
        return this.order.origin.charAt(0).toUpperCase() + this.order.origin.slice(1);
      }
      return 'POS'
    },
    locationVariationText() {
      if (this.order.locationVariation !== null && this.order.locationVariation !== undefined && this.order.locationVariation.label !== null && this.order.locationVariation.label !== undefined) {

        if (this.order.locationVariation.label.toLowerCase().includes('table')) {
          return this.order.locationVariation.label
        }

        else if (this.order.locationVariation.label.toLowerCase().includes('borð') || this.order.locationVariation.label.toLowerCase().includes('bord')) {
          return this.order.locationVariation.label
        }

        return 'Table ' + this.order.locationVariation.label

      }
      return ''
    },
    orderTags() {
      let returnString = ''
      if (this.order !== null && this.order !== undefined) {
        if (this.order.tags !== null && this.order.tags !== undefined && this.order.tags.length > 0) {
          for (let item in this.order.tags) {
            const currentTag = this.order.tags[item]
            if (currentTag !== null && currentTag !== undefined) {
              returnString += currentTag.name + ' '
            }
          }
        }
      }
      return returnString
    },
    deliveryTimeFormatted() {

      if(this.order.deliveryTimeInMillis === null || this.order.deliveryTimeInMillis === undefined || this.order.deliveryTimeInMillis === 0) {
        return ''
      }

      return this.$moment(this.order.deliveryTimeInMillis).format("MM/DD - HH:mm")
    },
    orderComment() {
      if(typeof this.order.comment === 'undefined' || this.order.comment === null) {
        return null
      }
      const orderComment = this.order.comment
      try {
        const commentObject = JSON.parse(orderComment)
        let commentString = ''
        for (const key in commentObject) {
          if(commentString !== '') {
            commentString += ',\n' + key + ': ' + commentObject[key]
          } else {
            commentString += key + ': ' + commentObject[key]
          }
        }
        return commentString.replace(/\n/g, "<br>")
      } catch (e) {
        return orderComment.replace(/\n/g, "<br>")
      }
    },
    fulfillment() {
      let includesTakeAwayItem = null
      let includesTakeawayTag = null


      includesTakeAwayItem = this.order.lineItems.some(
        (lineItem) =>
            lineItem !== null &&
            lineItem.label !== null &&
            lineItem.label !== undefined &&
            (
            lineItem.label.toLowerCase().includes("takeaway") ||
            lineItem.label.toLowerCase().includes("take away")
            )
      )

      if (Array.isArray(this.order.tags) && this.order.tags.length > 0) {
        includesTakeawayTag = this.order.tags.find(tag => tag !== null && tag !== undefined && tag.name !== null && tag.name !== undefined &&  (tag.name.toLowerCase().includes('take away') || tag.name.toLowerCase().includes('takeaway') || tag.name.toLowerCase().includes('take-away')))
      }

      if(typeof this.order.fulfillment !== 'undefined' && this.order.fulfillment !== null) {

        if(this.order.fulfillment.toLowerCase() === 'eatin' || this.order.fulfillment.toLowerCase() === 'eat in') {
          return 'eatIn'
        }

        if(this.order.fulfillment.toLowerCase() === 'delivery') {
          return 'delivery'
        }

        if (this.order.fulfillment.toLowerCase() === 'takeaway' ||
        this.order.fulfillment.toLowerCase() === 'take away') {
          return 'takeAway'
        }
      }

      if(
          includesTakeAwayItem ||
          includesTakeawayTag
        ) {
          return 'takeAway'
        }

      return 'eatIn'
    },
    headers() { 
      return [
        { text: "Qty", value: "qty" },
        { text: "Label", value: "label" },
        { text: "Total Price", value: "totalPrice" },
      ];
    },
    lineItems() {
      let lineItems = this.order.lineItems

      // Apply the category filter if there is one.
      if (this.processDisplaySystem !== null && this.processDisplaySystem !== undefined && Array.isArray(this.processDisplaySystem.categories) && this.processDisplaySystem.categories.length > 0) {
        let validCategories = this.processDisplaySystem.categories.reduce((array, category) => {
						if(category && category.uuid) {
							array.push(category.uuid)
						}
						return array
					}, [])

        if (Array.isArray(validCategories) && validCategories.length > 0) {

          lineItems = lineItems.filter((lItem) => {
            return lItem.item && lItem.item.categories && lItem.item.categories.some((category) => {
              return validCategories.includes(category.uuid)
            })
          })
          
        }
      }

      return lineItems.sort((l1, l2) => l1.label !== null && l2.label !== undefined && l1.label.localeCompare(l2.label));
    },
    processDisplaySystem() {
      return this.$store.state.processDisplaySystem;
    },
    timeOfRed() {
      return this.processDisplaySystem.timeOfRed;
    },
    timeOfYellow() {
      return this.processDisplaySystem.timeOfYellow;
    },
    showLocationVariation() {
      return this.processDisplaySystem.showLocationVariationOnOrderCard
    },
    backgroundColor() {
      return "dark";
    },
    orderStates() {
      return this.$store.state.orderStates;
    },
    isPosOrder() {
      return this.order.orderId === null || this.order.orderId === undefined
    }
  },
  methods: {
    tagInlcudesTakeaway(tag) {
      if (tag !== null && tag !== undefined && tag.name !== null && tag.name !== undefined && (tag.name.toLowerCase().includes("take away") || tag.name.toLowerCase().includes("takeaway") || tag.name.toLowerCase().includes('take-away'))) {
        return true
      }
      return false
    }, 
    errorMessage(errorCode) {
      switch (errorCode) {
        case 0:
          return "No error";
        case 3:
          return "error open port";
        case 4:
          return "error begin checkblock";
        case 5:
          return "error end checkblock";
        case 6:
          return "error read port";
        case 7:
          return "error write port";
        default:
          return "Error occured in printing";
      }
    },
    formatStringReplace(string) {
      const _localStringVariable = string.replaceAll("font-size: 14px", 'font-size: 22px');
      return _localStringVariable.replaceAll("font-size: 18px", 'font-size: 22px');
    }, 
    formatTime(time) {
      return this.$moment(time).format("HH:mm");
    },
    formatDateFromMillisec(millisec) {
      return this.$moment(millisec).format("DD.MM.YYYY");
    },
    clickOrder() {
      this.$emit("clickOrder", this.order);
    },
    stateColor(state) {
      let defaultColor = 'yellow'

      if (
        this.processDisplaySystem.stateColors !== null &&
        typeof this.processDisplaySystem.stateColors !== "undefined" &&
        this.processDisplaySystem.stateColors[state] !== null &&
        typeof this.processDisplaySystem.stateColors[state] !== "undefined" &&
        this.processDisplaySystem.stateColors[state] !== ""
      ) {
        return this.processDisplaySystem.stateColors[state];
      }

      try {
        
        const orderStateIndex = this.orderStates.findIndex((s) => {
          return s.key === state;
        });

        if(this.orderStates[orderStateIndex] !== null && this.orderStates[orderStateIndex] !== undefined) {
          defaultColor = this.orderStates[orderStateIndex].color
        }

      }
      catch(e) {
        // Do nothing
      }

      //take-away and deliveries are both red
      if(this.fulfillment === 'takeAway' || this.fulfillment === 'delivery') {
        defaultColor = 'red'
      }

      return defaultColor
    },
    proceedOrderStateForward() {
      
      if (this.order && this.order.state !== "delivered") {
        this.processingForward = true

        let nextState = this.order.state
        try {

          const orderStateIndex = this.orderStates.findIndex(s => s.key === this.order.state)
          if(orderStateIndex >= 0) {
            nextState = this.orderStates[orderStateIndex].nextStep
          }
        }
        catch(e) {
          // Do nothing
        }

        this.updateOrderState(nextState)
      }
    },
    processOrderStateBackward() {

      if (this.order && this.order.state !== "new" && this.order.state !== 'pending') {
        this.processingBackward = true

        let previousState = this.order.state
        try {

          const orderStateIndex = this.orderStates.findIndex(s => s.key === this.order.state)
          if(orderStateIndex >= 0) {
            previousState = this.orderStates[orderStateIndex].previousStep
          }
        }
        catch(e) {
          // Do nothing
        }

        this.updateOrderState(previousState)
      }
    },
    calculatePrinterWidth(type) {
      switch (type) {
        case 'star_mcp_2':
          return 385
        case 'star_mcp_3':
          return 576
        default:
            return 385
      }
    },
    updateOrderState(state) {

      if(this.isPosOrder === true) {
        this.$store.dispatch('updatePosOrderState', { uuid: this.order.uuid, state: state }).then(result => {
          this.showError = !result
          // Bugsnag notify?
        })
      } else {
        this.$store.dispatch('updateOrderState', { uuid: this.order.uuid, state: state }).then(result => {
          this.showError = !result
          // Bugsnag notify?
        })
      }

      if(this.processDisplaySystem && Array.isArray(this.processDisplaySystem.printers) && state === 'completed') {
        const _htmlString = this.getAsHtml()
        for(const i in this.processDisplaySystem.printers) {
          const printer = this.processDisplaySystem.printers[i]
          if(printer) {
            const printerWidth = this.calculatePrinterWidth(printer.model)
            try {
              const printRequest = {
                htmlString: _htmlString,
                ipAddress: printer.ipAddress,
                width: printerWidth
              }
              StarPrinterConnect.print(printRequest)
            } catch (e) {
              console.log(e)
              //
            }
          }
        }
      }

      this.order.state = state

      setTimeout(() => {
        this.processingForward = false
        this.processingBackward = false
      }, 300)
    },
    updateTime() {
      this.fromNow = moment(this.order.created).fromNow()
    },
    getAsHtml() {
      const _retVal = `<html>

                    <head>
                      <style>
                        ${this.styleForPrinterTicket}
                      </style>
                    </head>

                    <body>
                      <h3 class="text-center order-table">#${this.order.sequence ? this.order.sequence : this.order.orderId}</h3>

                      <h4 class="text-center text-normal">${this.order.origin ? this.orderOrigin : 'POS'}</h4>
                      
                      <h5 class="text-center order-shipping">${this.order.deliveryTimeInMillis ? this.formatTime(this.order.deliveryTimeInMillis) : ''}</h5>
                      <h5 class="text-center order-shipping">${this.order.deliveryTimeInMillis ? this.formatDateFromMillisec(this.order.deliveryTimeInMillis) : ''}</h5>

                      <h5 class="text-center order-table"> ${this.order.locationVariation ? this.order.locationVariation.label : '' } </h5>

                      <h6 class="text-center order-shipping">${this.order.location ? this.order.location.label : ''}</h6>

                      <table class="table text-normal">
                        <tbody>
                            <tr>
                                <td class="text-left">Date: ${this.formatDateFromMillisec(this.order.created)} </td>
                                <td class="text-right">Time:  ${this.formatTime(this.order.created)}</td>
                            </tr>
                        </tbody>
                      </table>

                      <hr class="receipt-seperator">

                      <table class="table text-normal">
                        <tbody>
                          <tr class="receipt-border-bottom">
                            <td class="text-left" style="max-width: 50px;">Qty</td>
                            <td class="text-left">Item</td>
                          </tr>
                          ${this.formatLineItemsToHtml()}
                        </tbody>
                      </table>
                      <hr class="receipt-seperator">

                      <h3 class="text-center order-table">#${this.order.sequence ? this.order.sequence : this.order.orderId}</h3>
                      <h4 class="text-center text-normal">${this.orderTags}</h4>
                      <h4 class="text-center text-normal">${this.order.origin ? this.orderOrigin : 'POS'}</h4>

                      <h5 class="text-center order-shipping">${this.order.deliveryTimeInMillis ? this.formatTime(this.order.deliveryTimeInMillis) : ''}</h5>
                      <h5 class="text-center order-shipping">${this.order.deliveryTimeInMillis ? this.formatDateFromMillisec(this.order.deliveryTimeInMillis) : ''}</h5>

                      <h5 class="text-center order-table"> ${this.order.locationVariation ? this.order.locationVariation.label : '' } </h5>

                      <h5 class="text-center order-contact">${this.order.customer?.address ? this.order.customer.address.name_line : ''}</h5>
                      <h6 class="text-center">${this.order.customer?.email ? this.order.customer.email : ''}</h6>
                      <h6 class="text-center">${this.order.customer?.phone ? this.order.customer.phone : ''}</h6>

                      <h2 class="text-center order-table" style="text-transform: capitalize;"> ${this.order.fulfillment ? this.order.fulfillment : ''} </h2>

                      <div class="text-center">
                        <img height="140" width="140" src="https://europe-west1-proton-mainframe.cloudfunctions.net/generateQRCode?qrContent=https://checkin.salescloud.is?uuid=${ this.order.uuid }">
                      </div>

                    </body>
                  </html>`
      return _retVal
    },
    formatLineItemsToHtml() {
      let html = "";
      this.order.lineItems.forEach((lineItem) => {
        html += `<tr class="receipt-border-bottom">
            <td class="text-left" style="max-width: 50px;"><strong>${lineItem.quantity}</strong></td>
            <td class="text-left"><strong>${lineItem.label}</strong></td>
          </tr>
          <tr class="sales-kitchen-receipt-dynamic-description">
            <td class="text-left" style="max-width: 50px;"></td>
            <td class="text-left">${this.formatStringReplace(lineItem.dynamicDescription)}</td>
          </tr>`
      });
      return html;
    },
  },
  created() {
    this.fromNow = moment(this.order.created).fromNow()
    this.interval = setInterval(this.updateTime, 10000)
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<style>
v-btn:hover {
  opacity: 1;
}
</style>
